function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  id: "general-expences",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1528 5.55553C10.2037 5.65919 10.2373 5.77021 10.2524 5.88434L10.5308 10.0243L10.669 12.1051C10.6705 12.3191 10.704 12.5317 10.7687 12.736C10.9356 13.1326 11.3372 13.3846 11.7741 13.367L18.4313 12.9315C18.7196 12.9268 18.998 13.0346 19.2052 13.2313C19.3779 13.3952 19.4894 13.6096 19.5246 13.8402L19.5364 13.9802C19.2609 17.7949 16.4592 20.9767 12.6524 21.798C8.84555 22.6193 4.94186 20.8843 3.06071 17.5349C2.51839 16.5618 2.17965 15.4923 2.06438 14.389C2.01623 14.0624 1.99503 13.7325 2.00098 13.4025C1.99503 9.31273 4.90747 5.77696 8.98433 4.92457C9.47501 4.84816 9.95603 5.10792 10.1528 5.55553Z",
  fill: "#00273D"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M12.87 2.00082C17.4298 2.11683 21.2623 5.39579 21.9999 9.81229L21.9929 9.84488L21.9728 9.89227L21.9756 10.0224C21.9651 10.1947 21.8986 10.3605 21.7839 10.4945C21.6645 10.634 21.5013 10.729 21.3215 10.7659L21.2119 10.7809L13.5312 11.2786C13.2757 11.3038 13.0213 11.2214 12.8313 11.052C12.673 10.9107 12.5717 10.7201 12.5431 10.5147L12.0276 2.84506C12.0186 2.81913 12.0186 2.79102 12.0276 2.76508C12.0346 2.55367 12.1277 2.35384 12.286 2.21023C12.4443 2.06662 12.6546 1.9912 12.87 2.00082Z",
  fill: "#00273D"
}));

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  viewBox: "0 0 24 24",
  id: "general-doc-clean",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M16.191 2H7.81C4.77 2 3 3.78 3 6.83v10.33C3 20.26 4.77 22 7.81 22h8.381C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2Z",
  fill: "#00273D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.08 6.65v.01a.78.78 0 0 0 0 1.56h2.989c.431 0 .781-.35.781-.791a.781.781 0 0 0-.781-.779H8.08Zm7.84 6.09H8.08a.78.78 0 0 1 0-1.561h7.84a.781.781 0 0 1 0 1.561Zm0 4.57H8.08c-.3.04-.59-.11-.75-.36a.795.795 0 0 1 .75-1.21h7.84c.399.04.7.38.7.79 0 .399-.301.74-.7.78Z",
  fill: "#00273D"
}));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  id: "general-boomerang",
  className: "aiconify aiconify--twemoji",
  viewBox: "0 0 36 36",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DD",
  d: "M31.497 6.06s.244-4.293-6.702-3.83c-8.617.574-18.599 9.155-18.95 17.159-.267 6.089 8.109 1.203 11.139-1.96-.045-.045 3.282 1.426 4.752 4.545-3.267 2.733-8.047 4.803-11.644 5.109-6.282.535-8.546-2.727-7.557-9.15C3.758 10 13.588.858 24.604.795c8.377-.048 6.893 5.265 6.893 5.265z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#662113",
  d: "M32.19 32.317c.351-1.768-.27-19.086-4.411-22.615S5.541 7.73 3.881 8.435c-2.24.95-1.352 3.835.184 3.93 5.43.339 16.02.786 18.774 3.133s4.875 12.732 6.07 18.04c.337 1.501 2.643 1.99 3.281-1.221z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C1694F",
  d: "M32.19 32.317c.432-1.75-.057-20.063-4.197-23.592s-22.3-1.109-23.96-.405c-2.24.95-1.291 2.972.245 3.068 5.43.339 16.02.786 18.774 3.133s4.875 12.732 6.07 18.04c.338 1.501 2.484 2.118 3.068-.244z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC4D",
  d: "M6.747 11.537c1.459.089 3.08.196 4.731.339l-.013-4.686a82.092 82.092 0 0 0-3.749.426l-.969 3.921zm21.836 18.61c-.319-1.426-.682-3.01-1.084-4.618l4.629-.73c.094 1.376.149 2.659.174 3.769l-3.719 1.579z"
}));

var _ref5 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-palette"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.41 5.367a1 1 0 10.513 1.932 1 1 0 00-.513-1.932zm-3.333-2a1 1 0 10.513 1.932 1 1 0 00-.513-1.932zm-3.334 2A1 1 0 105.257 7.3a1 1 0 00-.514-1.933zm0 4a1 1 0 10.514 1.933 1 1 0 00-.514-1.933z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.333.005A8 8 0 00.055 8a8.01 8.01 0 008 8c.226 0 .447-.015.667-.033a.667.667 0 00.61-.667l-.02-2.392a2.378 2.378 0 014.06-1.708l.066.067a1.274 1.274 0 001.18.347 1.259 1.259 0 00.917-.785 7.95 7.95 0 00.518-3.029A8.104 8.104 0 008.333.005zm5.988 10.266l-.009-.009a3.712 3.712 0 00-6.333 2.657l.016 1.748a6.667 6.667 0 11.295-13.33 6.751 6.751 0 016.43 6.496 6.595 6.595 0 01-.397 2.434l-.002.004z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-uploading"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3333 10.6667C15.1565 10.6667 14.987 10.7369 14.8619 10.8619C14.7369 10.9869 14.6667 11.1565 14.6667 11.3333V14C14.6667 14.1768 14.5964 14.3464 14.4714 14.4714C14.3464 14.5964 14.1768 14.6667 14 14.6667H2C1.82319 14.6667 1.65362 14.5964 1.5286 14.4714C1.40357 14.3464 1.33333 14.1768 1.33333 14V11.3333C1.33333 11.1565 1.2631 10.9869 1.13807 10.8619C1.01305 10.7369 0.843478 10.6667 0.666667 10.6667C0.489856 10.6667 0.320286 10.7369 0.195262 10.8619C0.0702379 10.9869 0 11.1565 0 11.3333L0 14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V11.3333C16 11.1565 15.9298 10.9869 15.8047 10.8619C15.6797 10.7369 15.5101 10.6667 15.3333 10.6667Z",
  fill: "#00273D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5286 3.64166L6.58593 0.583659C6.96159 0.209856 7.46998 1.04904e-05 7.99993 1.04904e-05C8.52988 1.04904e-05 9.03827 0.209856 9.41393 0.583659L12.4713 3.64099C12.5349 3.70249 12.5857 3.77605 12.6207 3.85739C12.6556 3.93873 12.674 4.02621 12.6748 4.11473C12.6755 4.20324 12.6587 4.29103 12.6251 4.37296C12.5916 4.45489 12.5421 4.52933 12.4795 4.59192C12.4169 4.65452 12.3425 4.70402 12.2606 4.73754C12.1786 4.77106 12.0909 4.78793 12.0023 4.78716C11.9138 4.78639 11.8263 4.768 11.745 4.73306C11.6637 4.69812 11.5901 4.64733 11.5286 4.58366L8.6666 1.72299V12.0003C8.6666 12.1771 8.59636 12.3467 8.47134 12.4717C8.34631 12.5968 8.17674 12.667 7.99993 12.667C7.82312 12.667 7.65355 12.5968 7.52853 12.4717C7.4035 12.3467 7.33326 12.1771 7.33326 12.0003V1.72233L4.47127 4.58433C4.40977 4.648 4.3362 4.69879 4.25487 4.73373C4.17353 4.76867 4.08605 4.78706 3.99753 4.78783C3.90901 4.7886 3.82123 4.77173 3.7393 4.73821C3.65737 4.70469 3.58293 4.65518 3.52034 4.59259C3.45774 4.52999 3.40824 4.45556 3.37472 4.37363C3.3412 4.2917 3.32433 4.20391 3.3251 4.11539C3.32587 4.02687 3.34426 3.93939 3.3792 3.85806C3.41414 3.77672 3.46493 3.70316 3.5286 3.64166Z",
  fill: "#00273D"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref7 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-add-user"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.333 7.333H14V6a.667.667 0 00-1.333 0v1.333h-1.334a.667.667 0 100 1.334h1.334V10A.667.667 0 0014 10V8.667h1.333a.667.667 0 100-1.334zM6 8a4 4 0 100-8 4 4 0 000 8zm0-6.667a2.667 2.667 0 110 5.334 2.667 2.667 0 010-5.334zm0 8a6.007 6.007 0 00-6 6 .666.666 0 101.333 0 4.667 4.667 0 019.334 0 .667.667 0 101.333 0 6.007 6.007 0 00-6-6z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref8 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-attach"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3 6.4a.667.667 0 00-.943 0l-7.261 7.293a3.335 3.335 0 01-4.714 0 3.334 3.334 0 010-4.714l7.032-7.062a2 2 0 012.829 2.828L5.21 11.807a.681.681 0 01-.943 0 .667.667 0 010-.943l6.262-6.29a.667.667 0 00-.943-.943l-6.261 6.29a2 2 0 000 2.829 2.049 2.049 0 002.828 0l7.032-7.062A3.333 3.333 0 008.471.975L1.44 8.036a4.667 4.667 0 006.6 6.6l7.261-7.29a.668.668 0 000-.946z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref9 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-big-arrow-down"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.032 10.859a.666.666 0 00-.943 0l-3.422 3.42V.667a.667.667 0 00-1.334 0v13.605l-3.412-3.413a.666.666 0 10-.943.941l3.613 3.613a2 2 0 002.828 0l3.613-3.613a.667.667 0 000-.941z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref10 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-big-arrow-left"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.135 13.037a.667.667 0 000-.943L1.715 8.67h13.613a.667.667 0 100-1.333H1.722l3.413-3.413a.667.667 0 10-.94-.943L.58 6.595a2 2 0 000 2.829l3.613 3.613a.667.667 0 00.941 0z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref11 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-big-arrow-right"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.358 13.471l4.058-4.057a2.005 2.005 0 000-2.828l-4.058-4.057a.667.667 0 10-.942.942l3.861 3.862H.667a.667.667 0 000 1.334h13.61l-3.861 3.861a.666.666 0 10.942.943z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref12 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-big-arrow-up"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.471 4.641L9.414.583a2.005 2.005 0 00-2.828 0L2.529 4.641a.667.667 0 10.942.943l3.862-3.861v13.61a.666.666 0 101.334 0V1.722l3.862 3.862a.667.667 0 10.942-.943z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref13 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-calendar"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 1.333H12V.667a.666.666 0 10-1.333 0v.666H5.333V.667A.667.667 0 104 .667v.666h-.667A3.337 3.337 0 000 4.667v8A3.337 3.337 0 003.333 16h9.334A3.337 3.337 0 0016 12.667v-8a3.338 3.338 0 00-3.333-3.334zM1.333 4.667a2 2 0 012-2h9.334a2 2 0 012 2v.666H1.333v-.666zm11.334 10H3.333a2 2 0 01-2-2v-6h13.334v6a2 2 0 01-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 10a1 1 0 100-2 1 1 0 000 2zm0 2.992a1 1 0 100-2 1 1 0 000 2zM4.667 10a1 1 0 100-2 1 1 0 000 2zm0 2.992a1 1 0 100-2 1 1 0 000 2zM11.333 10a1 1 0 100-2 1 1 0 000 2zm0 2.992a1 1 0 100-2 1 1 0 000 2z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref14 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-calendar-day"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.333h.667A3.337 3.337 0 0116 4.667v8A3.337 3.337 0 0112.667 16H3.333A3.337 3.337 0 010 12.667v-8a3.337 3.337 0 013.333-3.334H12zM1.92 3.253a2 2 0 00-.587 1.414v8a2 2 0 002 2h9.334a2 2 0 002-2v-8a2 2 0 00-2-2H3.333a2 2 0 00-1.414.585z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.333 9h-6v1.333h13.334V9h-6V2.667H7.333V9z",
  fill: "currentColor"
}));

var _ref15 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-calend-next"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.333 1.333H4V.667a.667.667 0 011.333 0v.666h5.334V.667a.667.667 0 111.333 0v.666h.667A3.337 3.337 0 0116 4.667v1.329c0 .37-.3.67-.671.67H1.334v2.995a2 2 0 002 2l10.444-.002-1.862-1.863a.669.669 0 01-.008-.95.667.667 0 01.95.008l2.058 2.057a2.005 2.005 0 010 2.828l-2.058 2.057a.668.668 0 01-1.146-.468.668.668 0 01.204-.474l1.861-1.862-10.444.002A3.337 3.337 0 010 9.662V4.667a3.337 3.337 0 013.333-3.334zm10.748 1.92a2 2 0 01.586 1.414v.666H1.333v-.666a2 2 0 012-2h9.334a2 2 0 011.414.585z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 10a1 1 0 100-2 1 1 0 000 2zm-3.333 0a1 1 0 100-2 1 1 0 000 2z",
  fill: "currentColor"
}));

var _ref16 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-calend-prev"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.667 1.333H12V.667a.666.666 0 10-1.333 0v.666H5.333V.667A.667.667 0 104 .667v.666h-.667A3.337 3.337 0 000 4.667v1.329c0 .37.3.67.671.67h13.995v2.995a2 2 0 01-2 2L2.223 11.66l1.862-1.863a.667.667 0 10-.943-.942L1.083 10.91a2.005 2.005 0 000 2.828l2.058 2.057a.669.669 0 00.951.009.667.667 0 00-.008-.951l-1.861-1.862 10.444.002A3.337 3.337 0 0016 9.662V4.667a3.338 3.338 0 00-3.333-3.334zM1.919 3.253a2 2 0 00-.586 1.414v.666h13.334v-.666a2 2 0 00-2-2H3.333a2 2 0 00-1.414.585z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 10a1 1 0 100-2 1 1 0 000 2zm3.333 0a1 1 0 100-2 1 1 0 000 2z",
  fill: "currentColor"
}));

var _ref17 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-case"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 2.667h-.734A3.34 3.34 0 008.667 0H7.333a3.34 3.34 0 00-3.266 2.667h-.734A3.337 3.337 0 000 6v6.667A3.337 3.337 0 003.333 16h9.334A3.337 3.337 0 0016 12.667V6a3.337 3.337 0 00-3.333-3.333zM7.333 1.333h1.334a2 2 0 011.877 1.334H5.456a2 2 0 011.877-1.334zM3.333 4h9.334a2 2 0 012 2v2H1.333V6a2 2 0 012-2zm9.334 10.667H3.333a2 2 0 01-2-2V9.333h6V10a.667.667 0 101.334 0v-.667h6v3.334a2 2 0 01-2 2z",
  fill: "currentColor"
}));

var _ref18 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-check"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.88 2.954l-9.213 9.212a.667.667 0 01-.945 0L1.159 8.6a.667.667 0 10-.944.945l3.564 3.563a2.005 2.005 0 002.833 0l9.212-9.21a.668.668 0 10-.945-.944z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref19 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-chevron-down"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.467 5.805a.667.667 0 00-.943 0L8.467 8.862a.68.68 0 01-.942 0L4.467 5.805a.667.667 0 00-.942.942L6.58 9.805a2 2 0 002.829 0l3.057-3.058a.667.667 0 000-.942z",
  fill: "currentColor"
}));

var _ref20 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-chevron-down-active"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.471 5.471a.667.667 0 00-.942 0L8.47 8.53a.68.68 0 01-.942 0L4.47 5.47a.667.667 0 00-.942.943L6.584 9.47a2 2 0 002.829 0l3.057-3.057a.667.667 0 000-.943z",
  fill: "#EA561E"
}));

var _ref21 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-chevron-left"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2 3.2a.667.667 0 010 .942L7.141 7.199a.68.68 0 000 .943l3.057 3.057a.666.666 0 01-.942.943L6.199 9.085a2 2 0 010-2.828l3.058-3.058a.667.667 0 01.942 0z",
  fill: "currentColor"
}));

var _ref22 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-chevron-right"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.809 3.2a.667.667 0 000 .942l3.057 3.057a.68.68 0 010 .943L5.809 11.2a.667.667 0 00.942.943L9.81 9.085a2 2 0 000-2.828L6.75 3.199a.667.667 0 00-.942 0z",
  fill: "currentColor"
}));

var _ref23 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-chevron-up"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.467 10.195a.666.666 0 01-.943 0L8.467 7.138a.68.68 0 00-.942 0l-3.058 3.057a.667.667 0 01-.942-.942L6.58 6.195a2 2 0 012.829 0l3.057 3.058a.667.667 0 010 .942z",
  fill: "currentColor"
}));

var _ref24 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-clock"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.667A6.666 6.666 0 1114.667 8 6.674 6.674 0 018 14.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4a.667.667 0 00-.667.667V7.55L5.086 8.958a.668.668 0 10.708 1.133l2.56-1.6a.667.667 0 00.313-.572V4.667A.667.667 0 008 4z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref25 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-compare"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.333 14.667H2A.667.667 0 011.333 14V.667A.667.667 0 100 .667V14a2 2 0 002 2h13.333a.666.666 0 100-1.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 13.333a.667.667 0 00.667-.666V8a.667.667 0 00-1.334 0v4.667a.667.667 0 00.667.666zm-5.333 0a.667.667 0 00.666-.666V8A.667.667 0 104 8v4.667a.667.667 0 00.667.666zm8 0a.667.667 0 00.666-.666v-8a.667.667 0 10-1.333 0v8a.667.667 0 00.667.666zm-5.334 0A.667.667 0 008 12.667v-8a.667.667 0 00-1.333 0v8a.667.667 0 00.666.666z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref26 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-contact"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 0H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h9.334A3.337 3.337 0 0016 12.667V3.333A3.337 3.337 0 0012.667 0zm-8 14.667V14a3.333 3.333 0 116.666 0v.667H4.667zm10-2a2 2 0 01-2 2V14a4.666 4.666 0 10-9.334 0v.667a2 2 0 01-2-2V3.333a2 2 0 012-2h9.334a2 2 0 012 2v9.334z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 2.667A2.667 2.667 0 108 8a2.667 2.667 0 000-5.333zm0 4A1.333 1.333 0 118 4a1.333 1.333 0 010 2.667z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref27 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-copy"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.103 2.181L12.581.61A2.014 2.014 0 0011.143 0H8a3.34 3.34 0 00-3.267 2.667h-.066A3.337 3.337 0 001.333 6v6.667A3.337 3.337 0 004.667 16h4A3.337 3.337 0 0012 12.667V12.6a3.339 3.339 0 002.667-3.267v-5.76a1.992 1.992 0 00-.564-1.392zM8.667 14.667h-4a2 2 0 01-2-2V6a2 2 0 012-2v5.333A3.337 3.337 0 008 12.667h2.667a2 2 0 01-2 2zm2.666-3.334H8a2 2 0 01-2-2v-6a2 2 0 012-2h2.667v1.334A1.334 1.334 0 0012 4h1.333v5.333a2 2 0 01-2 2z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref28 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-credit-card"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.667 11.333a1 1 0 100-2 1 1 0 000 2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.667 2H3.333A3.301 3.301 0 000 5.333v5.334A3.301 3.301 0 003.333 14h9.334A3.301 3.301 0 0016 10.667V5.333A3.301 3.301 0 0012.667 2zM3.333 3.333h9.334c1.133 0 2 .867 2 2H1.333c0-1.133.867-2 2-2zm9.334 9.334H3.333c-1.133 0-2-.867-2-2v-4h13.334v4c0 1.133-.867 2-2 2z",
  fill: "currentColor"
}));

var _ref29 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-cross-big"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.805 1.195a.667.667 0 00-.943 0L8 7.057 2.138 1.195a.667.667 0 00-.943.943L7.057 8l-5.862 5.862a.666.666 0 10.943.943L8 8.943l5.862 5.862a.667.667 0 00.943-.943L8.943 8l5.862-5.862a.667.667 0 000-.943z",
  fill: "currentColor"
}));

var _ref30 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-cross-small"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.767 3.233a.795.795 0 00-1.123 0L8 6.876 4.356 3.233a.795.795 0 00-1.123 1.123L6.876 8l-3.643 3.644a.794.794 0 001.123 1.123L8 9.124l3.644 3.643a.795.795 0 001.123-1.123L9.124 8l3.643-3.644a.795.795 0 000-1.123z",
  fill: "currentColor"
}));

var _ref31 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-dislike"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.967 8.2l-.47-3.333A3.35 3.35 0 0012.2 2H3.333A3.337 3.337 0 000 5.333v3.334A3.337 3.337 0 003.333 12h1.808l1.276 2.585a2.024 2.024 0 003.814-1.224L10.007 12h2.66a3.333 3.333 0 003.3-3.8zM3.333 3.333h1.334v7.334H3.333a2 2 0 01-2-2V5.333a2 2 0 012-2zM14.176 9.98a2 2 0 01-1.51.688H9.223a.665.665 0 00-.658.774l.352 2.134a.683.683 0 01-.155.56.714.714 0 01-1.148-.142l-1.46-2.954A.666.666 0 006 10.844v-7.51h6.2a2.008 2.008 0 011.98 1.72l.47 3.333a2.001 2.001 0 01-.474 1.592z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref32 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-doc-arrow-right"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.69 1.367L1.368 3.69A4.636 4.636 0 000 6.99v5.677A3.337 3.337 0 003.333 16h6a.667.667 0 100-1.333h-6a2 2 0 01-2-2V6.99c0-.072.01-.142.019-.211.005-.038.01-.075.013-.112h3.302a2 2 0 002-2V1.365l.112-.013c.07-.01.14-.019.211-.019H10a2 2 0 012 2v.5a.667.667 0 101.334 0v-.5A3.337 3.337 0 0010 0H6.99a4.636 4.636 0 00-3.3 1.367zm-1.9 3.966c.142-.255.317-.49.52-.7L4.633 2.31c.21-.203.445-.378.7-.52v2.878a.667.667 0 01-.666.666H1.789z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.358 13.646l2.058-2.057a2.005 2.005 0 000-2.828l-2.058-2.057a.667.667 0 10-.942.942l1.861 1.862h-7.61a.667.667 0 000 1.334h7.61l-1.861 1.861a.666.666 0 10.942.943z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref33 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-doc-check"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.967 3.69l-2.324-2.323A4.636 4.636 0 007.343 0h-3.01A3.337 3.337 0 001 3.333v9.334A3.337 3.337 0 004.333 16H11a3.337 3.337 0 003.333-3.333V6.99a4.635 4.635 0 00-1.366-3.3zm-.943.943c.203.21.378.445.52.7H9.668A.667.667 0 019 4.667V1.789c.255.142.49.317.7.52l2.324 2.324zM13 12.667a2 2 0 01-2 2H4.333a2 2 0 01-2-2V3.333a2 2 0 012-2h3.01c.11 0 .216.022.324.032v3.302a2 2 0 002 2h3.302c.01.108.031.213.031.323v5.677zm-2.184-3.793a.667.667 0 01-.023.942L8.4 12.092a2 2 0 01-2.817-.011l-1.027-.916a.667.667 0 01.888-.996l1.057.942a.668.668 0 00.97.027l2.4-2.287a.667.667 0 01.945.023z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref34 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-document"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.333 9.333a.667.667 0 01-.666.667H5.333a.667.667 0 110-1.333h5.334a.667.667 0 01.666.666zm-2.666 2H5.333a.667.667 0 000 1.334h3.334a.667.667 0 000-1.334zm6-4.343v5.677A3.337 3.337 0 0111.333 16H4.667a3.337 3.337 0 01-3.334-3.333V3.333A3.337 3.337 0 014.667 0h3.01a4.639 4.639 0 013.3 1.367l2.322 2.324a4.634 4.634 0 011.368 3.299zm-4.633-4.68a3.34 3.34 0 00-.7-.52v2.877a.667.667 0 00.666.666h2.877a3.324 3.324 0 00-.52-.7L10.034 2.31zm3.3 4.68c0-.11-.022-.215-.032-.323H10a2 2 0 01-2-2V1.365c-.108-.01-.214-.032-.323-.032h-3.01a2 2 0 00-2 2v9.334a2 2 0 002 2h6.666a2 2 0 002-2V6.99z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref35 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-dollar"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.288 2.667a2.047 2.047 0 012.045 2.045.667.667 0 101.334 0V4.63a3.382 3.382 0 00-3.379-3.297h-.621V.667a.667.667 0 00-1.334 0v.666h-.621a3.379 3.379 0 00-1.067 6.584l1.688.563v4.853h-.621a2.047 2.047 0 01-2.045-2.045.667.667 0 10-1.334 0v.082a3.382 3.382 0 003.379 3.297h.621v.666a.667.667 0 101.334 0v-.666h.621a3.38 3.38 0 001.067-6.584L8.667 7.52V2.667h.621zm.647 6.68a2.045 2.045 0 01-.647 3.986h-.621V8.925l1.268.422zM7.333 7.075l-1.266-.422a2.045 2.045 0 01.645-3.986h.621v4.408z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref36 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-dots-more"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.333 9.333a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm6.667 0a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm6.667 0a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z",
  fill: "currentColor"
}));

var _ref37 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-download"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.333 10.667a.667.667 0 00-.666.666V14a.667.667 0 01-.667.667H2A.667.667 0 011.333 14v-2.667a.667.667 0 10-1.333 0V14a2 2 0 002 2h12a2 2 0 002-2v-2.667a.666.666 0 00-.667-.666z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.529 9.025l3.057 3.058a2.005 2.005 0 002.828 0l3.057-3.057a.667.667 0 10-.942-.943l-2.862 2.861V.667a.667.667 0 00-1.334 0v10.278L4.471 8.083a.666.666 0 10-.942.942z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref38 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-edit"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.437.62L4.31 8.748a3.31 3.31 0 00-.976 2.357V12a.667.667 0 00.667.667h.895a3.312 3.312 0 002.357-.976l8.128-8.128a2.083 2.083 0 000-2.943 2.13 2.13 0 00-2.943 0zm2 2L6.31 10.748a2.013 2.013 0 01-1.414.585h-.228v-.228a2.01 2.01 0 01.585-1.414l8.128-8.128a.765.765 0 011.057 0 .749.749 0 010 1.057z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.333 5.986a.667.667 0 00-.666.667V10H12a2 2 0 00-2 2v2.667H3.333a2 2 0 01-2-2V3.333a2 2 0 012-2h6.028a.667.667 0 100-1.333H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h7.562a3.312 3.312 0 002.358-.976l1.77-1.772A3.314 3.314 0 0016 10.895V6.653a.666.666 0 00-.667-.667zm-3.023 8.095a1.984 1.984 0 01-.977.534V12a.667.667 0 01.667-.667h2.617a2.011 2.011 0 01-.534.976l-1.773 1.772z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref39 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-exclamation"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.667A6.666 6.666 0 1114.667 8 6.674 6.674 0 018 14.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 3.333A.667.667 0 007.333 4v5.333a.667.667 0 001.334 0V4A.667.667 0 008 3.333zM8.667 12a.667.667 0 10-1.334 0 .667.667 0 001.334 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref40 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-export"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.357 1.367L2.033 3.69a4.636 4.636 0 00-1.366 3.3v5.677A3.337 3.337 0 004 16h2a.667.667 0 000-1.333H4a2 2 0 01-2-2V6.99c0-.072.01-.142.018-.211.005-.038.01-.075.013-.112h3.302a2 2 0 002-2V1.365l.112-.013c.07-.01.14-.019.212-.019h3.01a2 2 0 012 2v.5a.667.667 0 101.333 0v-.5A3.337 3.337 0 0010.667 0h-3.01a4.636 4.636 0 00-3.3 1.367zM2.455 5.333c.143-.255.318-.49.521-.7L5.3 2.31c.21-.203.445-.378.7-.52v2.878a.667.667 0 01-.667.666H2.455z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.854 9.642l2.057-2.058a2.005 2.005 0 012.828 0l2.057 2.058a.669.669 0 01.009.95.666.666 0 01-.951-.008l-1.862-1.861v6.61a.667.667 0 11-1.334 0v-6.61l-1.862 1.861a.666.666 0 11-.942-.942z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref41 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-folder"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.414 6.046L10.357.989a3.339 3.339 0 00-4.714 0L.586 6.046A1.985 1.985 0 000 7.46v6.545a2 2 0 002 2h12a2 2 0 002-2V7.46a1.986 1.986 0 00-.586-1.414zM10 14.671H6V12.05a2 2 0 114 0v2.622zm4.667-.666a.667.667 0 01-.667.666h-2.667V12.05a3.333 3.333 0 10-6.666 0v2.622H2a.667.667 0 01-.667-.666V7.46a.67.67 0 01.196-.471l5.056-5.056a2.005 2.005 0 012.83 0l5.056 5.058a.672.672 0 01.196.469v6.545z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref42 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-home"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.867 2.483a.696.696 0 01-1.006.428l-1.544-.844A.68.68 0 005.019 2H3.333a2 2 0 00-2 2v.663l3.988-.028c.374-.002.679.3.679.675a.658.658 0 01-.654.658l-4.013.028V12a2 2 0 002 2h9.334a2 2 0 002-2V8.667a.667.667 0 111.333 0V12a3.337 3.337 0 01-3.333 3.333H3.333A3.337 3.337 0 010 12V4A3.337 3.337 0 013.333.667H5.02c.31 0 .616.072.894.21l1.594.8a.696.696 0 01.36.806z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 4.91V2a2.005 2.005 0 00-2-2h-2.91a.666.666 0 100 1.334h2.633L7.634 7.423a.667.667 0 10.943.943l6.09-6.09V4.91a.668.668 0 101.332 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref43 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-import"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.357 1.367L2.033 3.69a4.636 4.636 0 00-1.366 3.3v5.677A3.337 3.337 0 004 16h2a.667.667 0 000-1.333H4a2 2 0 01-2-2V6.99c0-.072.01-.142.018-.211.005-.038.01-.075.013-.112h3.302a2 2 0 002-2V1.365l.112-.013c.07-.01.14-.019.212-.019h3.01a2 2 0 012 2v.5a.667.667 0 101.333 0v-.5A3.337 3.337 0 0010.667 0h-3.01a4.636 4.636 0 00-3.3 1.367zM2.455 5.333c.143-.255.318-.49.521-.7L5.3 2.31c.21-.203.445-.378.7-.52v2.878a.667.667 0 01-.667.666H2.455z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.854 13.359l2.057 2.058a2.005 2.005 0 002.828 0l2.057-2.058a.67.67 0 00.009-.951.666.666 0 00-.951.008l-1.862 1.861v-6.61a.666.666 0 10-1.334 0v6.611l-1.862-1.862a.666.666 0 10-.942.943z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref44 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-info"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.667A6.666 6.666 0 1114.667 8 6.674 6.674 0 018 14.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 6.667h-.667a.667.667 0 100 1.333H8v4a.667.667 0 101.333 0V8A1.333 1.333 0 008 6.667zm0-1.334a1 1 0 100-2 1 1 0 000 2z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref45 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-like"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.182 5.147A3.33 3.33 0 0012.667 4h-2.66l.224-1.36a2.024 2.024 0 00-3.814-1.225L5.141 4H3.333A3.337 3.337 0 000 7.333v3.334A3.337 3.337 0 003.333 14H12.2a3.35 3.35 0 003.3-2.867l.47-3.333a3.333 3.333 0 00-.788-2.653zm-13.849 5.52V7.333a2 2 0 012-2h1.334v7.334H3.333a2 2 0 01-2-2zm13.314-3.054l-.47 3.333a2.007 2.007 0 01-1.977 1.72H6v-7.51a.667.667 0 00.153-.195l1.46-2.956a.713.713 0 011.148-.138.683.683 0 01.155.56L8.564 4.56a.667.667 0 00.658.773h3.445a2 2 0 011.98 2.28z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref46 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-list"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.667 4h10.666a.667.667 0 100-1.333H4.667a.667.667 0 100 1.333zm10.666 3.333H4.667a.667.667 0 000 1.334h10.666a.667.667 0 100-1.334zm0 4.667H4.667a.666.666 0 100 1.333h10.666a.667.667 0 100-1.333zm-14-7.333a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667zm0 4.666a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm0 4.667a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z",
  fill: "currentColor"
}));

var _ref47 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-loader"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.906 11.672a.765.765 0 00.054-.611.814.814 0 00-.416-.469.884.884 0 00-.644-.052.834.834 0 00-.494.396 6.603 6.603 0 01-3.19 2.887 7.066 7.066 0 01-4.387.396 6.783 6.783 0 01-3.707-2.263A6.199 6.199 0 011.681 8c0-1.435.508-2.828 1.441-3.955A6.783 6.783 0 016.829 1.78a7.066 7.066 0 014.387.396 6.603 6.603 0 013.19 2.887.81.81 0 00.206.244.858.858 0 00.615.187.877.877 0 00.317-.087.838.838 0 00.257-.195.79.79 0 00.196-.585.77.77 0 00-.091-.3c-.867-1.593-2.272-2.863-3.99-3.607A8.833 8.833 0 006.434.226C4.6.65 2.968 1.646 1.801 3.056A7.749 7.749 0 000 8c0 1.793.634 3.534 1.8 4.944 1.168 1.41 2.799 2.406 4.633 2.83a8.833 8.833 0 005.484-.495c1.717-.744 3.122-2.014 3.989-3.607z",
  fill: "url(#paint0_angular)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "general-paint0_angular",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(8.42175 2.65427 -2.54576 8.07746 8 8)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.892,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.986,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref48 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-mail"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667.667H3.333A3.337 3.337 0 000 4v8a3.337 3.337 0 003.333 3.333h9.334A3.337 3.337 0 0016 12V4A3.337 3.337 0 0012.667.667zM3.333 2h9.334a2 2 0 011.853 1.258L9.415 8.364a2.005 2.005 0 01-2.83 0L1.48 3.258A2 2 0 013.333 2zm9.334 12H3.333a2 2 0 01-2-2V5l4.31 4.307a3.338 3.338 0 004.714 0L14.667 5v7a2 2 0 01-2 2z",
  fill: "currentColor"
}));

var _ref49 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-minus"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.333 7.333H1.667a.667.667 0 000 1.334h12.666a.667.667 0 100-1.334z",
  fill: "currentColor"
}));

var _ref50 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-plus"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.667 10.667a.667.667 0 01-.667.666H8.667v1.334a.667.667 0 11-1.334 0v-1.334H6A.667.667 0 116 10h1.333V8.667a.667.667 0 011.334 0V10H10a.667.667 0 01.667.667zm4-3.677v5.677A3.337 3.337 0 0111.333 16H4.667a3.337 3.337 0 01-3.334-3.333V3.333A3.337 3.337 0 014.667 0h3.01a4.639 4.639 0 013.3 1.367l2.322 2.324a4.634 4.634 0 011.368 3.299zm-4.633-4.68a3.34 3.34 0 00-.7-.52v2.877a.667.667 0 00.666.666h2.877a3.324 3.324 0 00-.52-.7L10.034 2.31zm3.3 4.68c0-.11-.022-.215-.032-.323H10a2 2 0 01-2-2V1.365c-.108-.01-.214-.032-.323-.032h-3.01a2 2 0 00-2 2v9.334a2 2 0 002 2h6.666a2 2 0 002-2V6.99z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref51 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-plus-big"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.333 7.333H8.667V1.667a.667.667 0 00-1.334 0v5.666H1.667a.667.667 0 000 1.334h5.666v5.666a.667.667 0 101.334 0V8.667h5.666a.667.667 0 100-1.334z",
  fill: "currentColor"
}));

var _ref52 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-plus-small"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.333 7.333H8.667V4.667a.667.667 0 00-1.334 0v2.666H4.667a.667.667 0 000 1.334h2.666v2.666a.667.667 0 101.334 0V8.667h2.666a.667.667 0 100-1.334z",
  fill: "currentColor"
}));

var _ref53 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-print"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 4V2.667A2.667 2.667 0 0010 0H6a2.667 2.667 0 00-2.667 2.667V4A3.337 3.337 0 000 7.333v3.334A3.337 3.337 0 003.333 14a2 2 0 002 2h5.334a2 2 0 002-2A3.337 3.337 0 0016 10.667V7.333A3.337 3.337 0 0012.667 4zm-8-1.333A1.333 1.333 0 016 1.333h4a1.333 1.333 0 011.333 1.334V4H4.667V2.667zM11.333 14a.667.667 0 01-.666.667H5.333A.667.667 0 014.667 14v-2.667a.667.667 0 01.666-.666h5.334a.667.667 0 01.666.666V14zm3.334-3.333a2 2 0 01-2 2v-1.334a2 2 0 00-2-2H5.333a2 2 0 00-2 2v1.334a2 2 0 01-2-2V7.333a2 2 0 012-2h9.334a2 2 0 012 2v3.334z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6.667h-1.333a.667.667 0 100 1.333H12a.667.667 0 100-1.333z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref54 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-question"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.667A6.666 6.666 0 1114.667 8 6.674 6.674 0 018 14.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.478 3.375A2.667 2.667 0 005.333 6a.667.667 0 001.334 0 1.333 1.333 0 012.276-.942c.19.19.32.43.371.694a1.333 1.333 0 01-.667 1.417 2.636 2.636 0 00-1.314 2.336V10a.667.667 0 101.334 0v-.495a1.321 1.321 0 01.62-1.168 2.667 2.667 0 00-.809-4.962zM8.667 12a.667.667 0 10-1.334 0 .667.667 0 001.334 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref55 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-redo"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 6.667A2.667 2.667 0 108 12a2.667 2.667 0 000-5.333zm0 4A1.333 1.333 0 118 8a1.333 1.333 0 010 2.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.024 2.748L13.252.976A3.31 3.31 0 0010.895 0H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h9.334A3.337 3.337 0 0016 12.667V5.105a3.312 3.312 0 00-.976-2.357zm-3.69-1.361V2a2 2 0 01-2 2H6.666a2 2 0 01-2-2v-.667h6.228c.148.002.295.02.438.054zm3.333 11.28a2 2 0 01-2 2H3.333a2 2 0 01-2-2V3.333a2 2 0 012-2V2a3.337 3.337 0 003.334 3.333h2.666a3.327 3.327 0 003.308-3.082l1.44 1.44c.374.376.584.884.586 1.414v7.562z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref56 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-save"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 15.333v-4.666a6.007 6.007 0 016-6h3.22V3.609a1.333 1.333 0 012.276-.942l3.92 3.919a2 2 0 010 2.828l-3.92 3.92a1.333 1.333 0 01-2.276-.943v-1.058H5.333a4.004 4.004 0 00-4 4 .667.667 0 11-1.333 0zm10.553-10A.667.667 0 019.887 6H6a4.672 4.672 0 00-4.667 4.667v1.142a5.324 5.324 0 014-1.809h4.554a.667.667 0 01.666.667v1.724l3.92-3.92a.667.667 0 000-.942l-3.92-3.92v1.724z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref57 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-search"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.805 14.862l-3.98-3.98a6.678 6.678 0 10-.942.943l3.98 3.98a.667.667 0 00.942-.943zM6.667 12A5.334 5.334 0 1112 6.667 5.34 5.34 0 016.667 12z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref58 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-shuffle"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.614 11.055L13.42 8.861a.667.667 0 10-.942.943l1.527 1.53a6.222 6.222 0 01-4.458-1.867.655.655 0 00-.938.053l-.009.013a.667.667 0 00.05.922 7.451 7.451 0 005.357 2.212l-1.529 1.528a.667.667 0 10.942.938l2.194-2.194a1.333 1.333 0 000-1.884z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.005 4.667l-1.527 1.526a.596.596 0 00-.036.055.661.661 0 00.978.888L14.557 6l1.058-1.057a1.333 1.333 0 00.304-1.4 1.313 1.313 0 00-.305-.485L13.42.867a.665.665 0 00-1.157.465.667.667 0 00.215.477l1.529 1.528c-3.289.008-5.092 1.782-6.726 3.649C5.779 5.291 4 3.6.99 3.364l-.32-.03A.667.667 0 00.004 4a.68.68 0 00.667.667c.048 0 .191.022.191.022C3.459 4.885 4.95 6.348 6.4 8 4.959 9.644 3.478 11.133.902 11.307l-.267.014a.663.663 0 10.083 1.323c.104-.005.273-.009.357-.015 3.346-.258 5.162-2.4 6.78-4.273 1.635-1.89 3.179-3.677 6.15-3.69z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref59 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-sign-in"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.667 14.667H3.333a2 2 0 01-2-2V3.333a2 2 0 012-2h1.334a.667.667 0 100-1.333H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h1.334a.666.666 0 100-1.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.975 3.529L4.917 6.586a2.005 2.005 0 000 2.828l3.057 3.057a.666.666 0 10.943-.942L6.056 8.667h9.277a.667.667 0 100-1.334H6.055l2.862-2.862a.667.667 0 10-.942-.942z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref60 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-sign-out"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.667 14.667H3.333a2 2 0 01-2-2V3.333a2 2 0 012-2h1.334a.667.667 0 100-1.333H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h1.334a.666.666 0 100-1.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.358 3.529l3.058 3.057a2.005 2.005 0 010 2.828l-3.057 3.057a.665.665 0 01-1.097-.21.666.666 0 01.154-.732l2.861-2.862H5a.667.667 0 110-1.334h9.278l-2.862-2.862a.666.666 0 11.942-.942z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref61 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-time"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.667A6.666 6.666 0 1114.667 8 6.674 6.674 0 018 14.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4a.667.667 0 00-.667.667V7.55L5.086 8.958a.668.668 0 10.708 1.133l2.56-1.6a.667.667 0 00.313-.572V4.667A.667.667 0 008 4z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref62 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-trash"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 2.667h-2.067A3.34 3.34 0 008.667 0H7.333a3.34 3.34 0 00-3.266 2.667H2A.667.667 0 102 4h.667v8.667A3.337 3.337 0 006 16h4a3.337 3.337 0 003.333-3.333V4H14a.666.666 0 100-1.333zM7.333 1.333h1.334a2.004 2.004 0 011.886 1.334H5.447a2.004 2.004 0 011.886-1.334zM12 12.667a2 2 0 01-2 2H6a2 2 0 01-2-2V4h8v8.667z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.667 12a.666.666 0 00.666-.667v-4a.667.667 0 10-1.333 0v4a.667.667 0 00.667.667zm2.666 0a.666.666 0 00.667-.667v-4a.667.667 0 00-1.333 0v4a.667.667 0 00.666.667z",
  fill: "currentColor"
}));

var _ref63 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-un-attach"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.319 6.148l-1.88 1.888a4.667 4.667 0 006.6 6.6l1.88-1.888-.943-.943-1.88 1.888a3.335 3.335 0 01-4.714 0 3.334 3.334 0 010-4.714l1.88-1.888-.943-.943zm3.766-1.892l-.942-.943L8.47.975a3.333 3.333 0 014.714 4.713l-2.329 2.339-.942-.943 2.329-2.339a2 2 0 00-2.829-2.828L7.085 4.256zM5.204 8.033l-1.88 1.888a2 2 0 000 2.829 2.049 2.049 0 002.83 0l1.879-1.888-.943-.943-1.88 1.888a.681.681 0 01-.943 0 .667.667 0 010-.943l1.88-1.888-.943-.943zM8.97 6.14l-.943-.943 1.559-1.566a.667.667 0 01.943.943L8.969 6.14zm2.829 2.83l.944.943L15.3 7.345a.668.668 0 10-.943-.945L11.8 8.97z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.471 1.472a.667.667 0 000 .942l11.774 11.773a.667.667 0 00.942-.942L2.414 1.472a.667.667 0 00-.943 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref64 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-undo"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.333 16a.666.666 0 01-.666-.667 4.004 4.004 0 00-4-4H6.78v1.058a1.333 1.333 0 01-2.276.942L.584 9.414a2 2 0 010-2.828l3.92-3.92a1.333 1.333 0 012.276.943v1.058H10a6.006 6.006 0 016 6v4.666a.667.667 0 01-.667.667zM5.447 3.61l-3.92 3.919a.667.667 0 000 .942l3.92 3.92v-1.724A.666.666 0 016.113 10h4.554a5.322 5.322 0 014 1.81v-1.143A4.672 4.672 0 0010 6H6.113a.667.667 0 01-.666-.667V3.61z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref65 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-upload"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 8.667a3 3 0 110-6 3 3 0 010 6zM5 4a1.667 1.667 0 100 3.333A1.667 1.667 0 005 4zm5 11.333V15a5 5 0 10-10 0v.333a.667.667 0 101.333 0V15a3.666 3.666 0 117.334 0v.333a.667.667 0 101.333 0zM16 12a4.666 4.666 0 00-7.778-3.478.667.667 0 10.89.993A3.333 3.333 0 0114.666 12 .667.667 0 1016 12zm-4.333-6a3 3 0 110-6 3 3 0 010 6zm0-4.667a1.667 1.667 0 100 3.334 1.667 1.667 0 000-3.334z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref66 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42 42",
  id: "general-settings-dots"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 7.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 7.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  opacity: 0.3,
  fill: "#00273D"
}));

var _ref67 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-contractor"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M2 11.079c.05 2.338.19 6.337.21 6.778.071.943.432 1.896.994 2.568.782.943 1.745 1.364 3.088 1.364 1.856.01 3.902.01 5.89.01 1.994 0 3.93 0 5.565-.01 1.324 0 2.317-.432 3.09-1.364.561-.672.922-1.635.973-2.568.02-.371.12-4.712.18-6.778H2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.245 15.384v1.294a.75.75 0 001.5 0v-1.294a.75.75 0 00-1.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.211 14.556a.75.75 0 01-.827.545c-2.55-.356-4.989-1.26-7.047-2.62A.747.747 0 012 11.855V8.39c0-2.1 1.712-3.808 3.817-3.808h1.967a2.953 2.953 0 012.92-2.58h2.582a2.953 2.953 0 012.92 2.58h1.977A3.812 3.812 0 0121.99 8.39v3.466a.753.753 0 01-.336.626c-2.062 1.365-4.51 2.274-7.078 2.63a.75.75 0 01-.83-.558A1.805 1.805 0 0011.99 13.2c-.842 0-1.557.545-1.779 1.357zM13.286 3.5h-2.582c-.673 0-1.235.46-1.403 1.081h5.387a1.456 1.456 0 00-1.402-1.08z"
})));

var _ref68 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-corpdoc"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.884 5.115h-2.943a2.43 2.43 0 01-1.894-.887l-.969-1.34A2.367 2.367 0 009.193 2h-2.08C3.378 2 2 4.192 2 7.92v4.028c-.005.443 19.996.443 19.997 0v-1.17c.018-3.728-1.325-5.662-5.113-5.662z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.832 6.543c.32.375.567.805.73 1.27.318.954.465 1.957.435 2.963v5.253a9.346 9.346 0 01-.098 1.322 5.991 5.991 0 01-.8 2.183 4.436 4.436 0 01-.676.888 6 6 0 01-4.366 1.57H7.931a6.027 6.027 0 01-4.375-1.57 4.437 4.437 0 01-.667-.888 5.83 5.83 0 01-.782-2.183A8.202 8.202 0 012 16.03v-5.253c0-.439.024-.877.071-1.313.01-.077.025-.152.04-.226.025-.125.049-.247.049-.369.09-.526.255-1.037.49-1.517.693-1.482 2.115-2.236 4.445-2.236h9.78a5.22 5.22 0 013.628 1.1c.119.1.229.21.33.328zM6.97 15.541h10.083a.828.828 0 00.863-.799.744.744 0 00-.178-.532.783.783 0 00-.622-.32H6.97a.826.826 0 100 1.651z"
})));

var _ref69 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-dashboard"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.075 2h3.386A2.549 2.549 0 0122 4.56v3.415a2.549 2.549 0 01-2.539 2.56h-3.386a2.549 2.549 0 01-2.538-2.56V4.56A2.549 2.549 0 0116.075 2z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.539 2h3.385a2.549 2.549 0 012.539 2.56v3.415a2.549 2.549 0 01-2.539 2.56H4.54A2.549 2.549 0 012 7.974V4.56A2.549 2.549 0 014.539 2zm0 11.466h3.385a2.549 2.549 0 012.539 2.56v3.414A2.55 2.55 0 017.924 22H4.54A2.55 2.55 0 012 19.44v-3.415a2.549 2.549 0 012.539-2.56zm14.923 0h-3.386a2.549 2.549 0 00-2.539 2.56v3.414A2.55 2.55 0 0016.076 22h3.386A2.55 2.55 0 0022 19.44v-3.415a2.549 2.549 0 00-2.538-2.56z"
})));

var _ref70 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-doc"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M18.809 9.021c-.452 0-1.05-.01-1.794-.01-1.816 0-3.31-1.503-3.31-3.336V2.459A.456.456 0 0013.254 2h-5.29C5.496 2 3.5 4.026 3.5 6.509v10.775C3.5 19.889 5.59 22 8.17 22h7.876c2.46 0 4.454-2.013 4.454-4.498V9.471a.453.453 0 00-.453-.458c-.422.003-.93.008-1.238.008z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.084 2.567a.477.477 0 00-.821.334v2.637c0 1.106.91 2.016 2.017 2.016.697.008 1.665.01 2.487.008a.477.477 0 00.343-.808l-4.026-4.187z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.974 11.388h3.385a.745.745 0 100-1.49H8.974a.745.745 0 000 1.49zm0 4.994h5.444a.745.745 0 100-1.49H8.974a.745.745 0 000 1.49z",
  fill: "currentColor"
})));

var _ref71 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-expenses"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.153 5.556c.05.103.084.214.1.328l.278 4.14.138 2.081c.002.214.035.427.1.631.167.397.568.649 1.005.631l6.657-.436c.289-.004.567.104.774.3.173.164.284.379.32.61l.011.14c-.275 3.814-3.077 6.996-6.884 7.817-3.806.821-7.71-.914-9.591-4.263a8.214 8.214 0 01-.997-3.146 6.02 6.02 0 01-.063-.986c-.006-4.09 2.906-7.626 6.983-8.478.491-.077.972.183 1.169.63z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M12.87 2c4.56.117 8.392 3.396 9.13 7.812l-.007.033-.02.047.003.13a.8.8 0 01-.192.473.827.827 0 01-.462.27l-.11.016-7.68.498a.917.917 0 01-.7-.227.884.884 0 01-.289-.537l-.515-7.67a.123.123 0 010-.08.785.785 0 01.258-.555.815.815 0 01.584-.21z",
  fill: "currentColor"
})));

var _ref72 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-msg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M22 15.94c0 2.79-2.24 5.05-5.03 5.06H7.05C4.27 21 2 18.75 2 15.96v-.01s.006-4.426.014-6.652a.498.498 0 01.808-.392c2.376 1.885 6.625 5.322 6.678 5.367.71.57 1.61.89 2.53.89.92 0 1.82-.32 2.53-.9.053-.036 4.207-3.37 6.619-5.286a.5.5 0 01.811.39c.01 2.21.01 6.573.01 6.573z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.476 5.674A5.035 5.035 0 0017.03 3H7.05a5.035 5.035 0 00-4.446 2.674.864.864 0 00.221 1.078l7.425 5.939c.52.42 1.15.629 1.78.629h.02c.63 0 1.26-.21 1.78-.63l7.425-5.938a.864.864 0 00.221-1.078z"
})));

var _ref73 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-users"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.95 14.54c-3.45 0-6.362.564-6.362 2.74S8.518 20 11.95 20c3.45 0 6.361-.564 6.361-2.74s-2.93-2.72-6.36-2.72z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M11.949 12.467a4.207 4.207 0 004.21-4.233A4.206 4.206 0 0011.948 4a4.206 4.206 0 00-4.21 4.234 4.207 4.207 0 004.21 4.233zm9.139-3.247c.604-2.378-1.168-4.513-3.424-4.513-.245 0-.48.027-.71.073-.03.007-.064.022-.082.05-.02.033-.005.08.018.109a5.807 5.807 0 011.067 3.37 5.762 5.762 0 01-.984 3.242.158.158 0 00.106.244c.158.028.32.042.484.047 1.643.043 3.118-1.02 3.525-2.623z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.81 14.817c-.302-.645-1.028-1.087-2.132-1.304-.521-.128-1.931-.308-3.243-.284-.02.003-.03.017-.032.026-.003.012.002.034.028.047.607.302 2.95 1.614 2.655 4.381-.012.12.084.224.203.206.576-.083 2.06-.404 2.52-1.402a1.922 1.922 0 000-1.67z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M7.045 4.78a3.514 3.514 0 00-.71-.073c-2.256 0-4.028 2.135-3.422 4.513.406 1.602 1.88 2.665 3.524 2.622.165-.005.327-.02.483-.047a.158.158 0 00.107-.244 5.764 5.764 0 01-.984-3.241 5.8 5.8 0 011.068-3.37c.022-.03.038-.076.016-.11-.018-.029-.05-.043-.082-.05z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.322 13.513c-1.104.217-1.83.659-2.13 1.304a1.918 1.918 0 000 1.67c.46.998 1.943 1.32 2.52 1.401.119.018.214-.084.201-.205-.294-2.766 2.05-4.079 2.656-4.38.025-.015.03-.035.028-.049-.002-.009-.012-.022-.031-.024-1.313-.025-2.722.155-3.244.283z"
})));

var _ref74 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-wallet"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#00273D"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.996 8.375h-4.234c-1.97.004-3.567 1.56-3.57 3.482-.004 1.925 1.595 3.489 3.57 3.491H22v.306C22 19.014 19.964 21 16.517 21H7.484C4.036 21 2 19.014 2 15.654V8.338C2 4.978 4.036 3 7.484 3h9.03c3.446 0 5.482 1.979 5.482 5.338v.037zM6.74 8.367h5.65a.756.756 0 00.762-.75.757.757 0 00-.769-.742H6.74a.756.756 0 00-.762.744.756.756 0 00.762.748z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M16.037 12.297c.21.95 1.044 1.62 1.996 1.603h3.25a.726.726 0 00.717-.734v-2.532a.728.728 0 00-.718-.734h-3.326c-1.083.004-1.958.902-1.956 2.01 0 .13.013.26.037.387z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 11.9,
  r: 1
})));

var _ref75 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "general-transparent"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 75,
  r: 20,
  stroke: "transparent",
  fill: "transparent",
  strokeWidth: 5
}));

var _ref76 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  id: "general-cb-rounded-active"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#00273D",
  fillOpacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.746 12a1.245 1.245 0 01-.904-.385l-1.606-1.64A.826.826 0 015 9.392a.841.841 0 01.236-.584.797.797 0 011.14 0l1.37 1.4 3.877-3.966a.798.798 0 011.316.267.843.843 0 01-.175.9l-4.116 4.209a1.268 1.268 0 01-.902.382z",
  fill: "#fff"
}));

var _ref77 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  id: "general-cb-rounded"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#00273D",
  fillOpacity: 0.04
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8,
  stroke: "#00273D",
  strokeOpacity: 0.04,
  strokeWidth: 2
}));

var _ref78 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-checkbox"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 0H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h9.334A3.337 3.337 0 0016 12.667V3.333A3.337 3.337 0 0012.667 0z",
  fill: "#1DD278"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.392 10.614L4.029 7.898a.566.566 0 00-.426-.202.566.566 0 00-.426.202.749.749 0 00-.177.49c0 .184.063.36.177.49l2.362 2.716c.112.129.245.23.392.3a1.073 1.073 0 00.923 0c.146-.07.28-.171.391-.3l5.578-6.411a.749.749 0 00.177-.49.749.749 0 00-.177-.49.566.566 0 00-.426-.203.566.566 0 00-.426.203l-5.579 6.411z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref79 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-zero-checkbox"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 0H3.333A3.337 3.337 0 000 3.333v9.334A3.337 3.337 0 003.333 16h9.334A3.337 3.337 0 0016 12.667V3.333A3.337 3.337 0 0012.667 0zm2 12.667a2 2 0 01-2 2H3.333a2 2 0 01-2-2V3.333a2 2 0 012-2h9.334a2 2 0 012 2v9.334z",
  fill: "#00273D",
  fillOpacity: 0.3
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref80 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 16",
  id: "general-mail-in"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667.667H3.333A3.337 3.337 0 000 4v8a3.337 3.337 0 003.333 3.333h9.334A3.337 3.337 0 0016 12V4A3.337 3.337 0 0012.667.667zM3.333 2h9.334a2 2 0 011.853 1.258L9.415 8.364a2.005 2.005 0 01-2.83 0L1.48 3.258A2 2 0 013.333 2zm9.334 12H3.333a2 2 0 01-2-2V5l4.31 4.307a3.338 3.338 0 004.714 0L14.667 5v7a2 2 0 01-2 2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.641 12.471l-3.058-3.057a2.005 2.005 0 010-2.828l3.058-3.057a.667.667 0 11.943.942l-2.861 2.862h9.61a.667.667 0 110 1.334h-9.61l2.861 2.862a.668.668 0 01-.469 1.146.664.664 0 01-.474-.204z",
  fill: "#EA561E"
}));

var _ref81 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 16",
  id: "general-mail-out"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667.667H3.333A3.337 3.337 0 000 4v8a3.337 3.337 0 003.333 3.333h9.334A3.337 3.337 0 0016 12V4A3.337 3.337 0 0012.667.667zM3.333 2h9.334a2 2 0 011.853 1.258L9.415 8.364a2.005 2.005 0 01-2.83 0L1.48 3.258A2 2 0 013.333 2zm9.334 12H3.333a2 2 0 01-2-2V5l4.31 4.307a3.338 3.338 0 004.714 0L14.667 5v7a2 2 0 01-2 2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.358 12.471l3.058-3.057a2.005 2.005 0 000-2.828l-3.058-3.057a.667.667 0 10-.942.942l2.861 2.862h-9.61a.667.667 0 100 1.334h9.61l-2.861 2.862a.665.665 0 00.21 1.096.666.666 0 00.732-.154z",
  fill: "#369CD7"
}));

var _ref82 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13",
  id: "general-portfolio"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.292 2.167h-.596A2.713 2.713 0 007.042 0H5.958a2.713 2.713 0 00-2.654 2.167h-.596A2.712 2.712 0 000 4.875v5.417A2.712 2.712 0 002.708 13h7.584A2.712 2.712 0 0013 10.292V4.875a2.712 2.712 0 00-2.708-2.708zM5.958 1.083h1.084a1.625 1.625 0 011.525 1.084H4.433a1.625 1.625 0 011.525-1.084zM2.708 3.25h7.584a1.625 1.625 0 011.625 1.625V6.5H1.083V4.875A1.625 1.625 0 012.708 3.25zm7.584 8.667H2.708a1.625 1.625 0 01-1.625-1.625V7.583h4.875v.542a.542.542 0 001.084 0v-.542h4.875v2.709a1.625 1.625 0 01-1.625 1.625z",
  fill: "#00273D"
}));

var _ref83 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  id: "general-star-fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.664 6.2l1.78 1.3-.676 2.094A1.59 1.59 0 002.36 11.4a1.588 1.588 0 001.9-.01L6 10.11l1.741 1.279a1.613 1.613 0 002.492-1.795L9.557 7.5l1.78-1.3a1.613 1.613 0 00-.95-2.916H8.2l-.663-2.068a1.614 1.614 0 00-3.073 0L3.8 3.284H1.616A1.613 1.613 0 00.666 6.2H.664z",
  fill: "#FBB916"
}));

var _ref84 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  id: "general-star-not-fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.664 6.2l1.78 1.3-.676 2.094A1.59 1.59 0 002.36 11.4a1.588 1.588 0 001.9-.01L6 10.11l1.741 1.279a1.613 1.613 0 002.492-1.795L9.557 7.5l1.78-1.3a1.613 1.613 0 00-.95-2.916H8.2l-.663-2.068a1.614 1.614 0 00-3.073 0L3.8 3.284H1.616A1.613 1.613 0 00.666 6.2H.664z",
  fill: "#EDF0F2"
}));

var _ref85 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  id: "general-star-semi-fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.664 6.2l1.78 1.3-.676 2.094A1.59 1.59 0 002.36 11.4a1.588 1.588 0 001.9-.01L6 10.11l1.741 1.279a1.613 1.613 0 002.492-1.795L9.557 7.5l1.78-1.3a1.613 1.613 0 00-.95-2.916H8.2l-.663-2.068a1.614 1.614 0 00-3.073 0L3.8 3.284H1.616A1.613 1.613 0 00.666 6.2H.664z",
  fill: "#EDF0F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.664 6.2l1.78 1.3-.676 2.094A1.59 1.59 0 002.36 11.4a1.588 1.588 0 001.9-.01L6 10.11V.095s-.675.109-.95.31a1.613 1.613 0 00-.586.811L3.8 3.284H1.616A1.613 1.613 0 00.666 6.2H.664z",
  fill: "#FBB916"
}));

var _ref86 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13",
  id: "general-board"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.292 1.083H8.916A3.199 3.199 0 005.85.063a3.118 3.118 0 00-1.74 1.02H2.709A2.712 2.712 0 000 3.792v6.5A2.712 2.712 0 002.708 13h7.584A2.712 2.712 0 0013 10.292v-6.5a2.712 2.712 0 00-2.708-2.709zm-3.792 0A2.167 2.167 0 018.667 3.25a.542.542 0 01-.542.542H6.97l.522-.783a.542.542 0 10-.901-.601l-.922 1.384h-.794a.542.542 0 01-.542-.542A2.167 2.167 0 016.5 1.083zm5.417 9.209a1.625 1.625 0 01-1.625 1.625H2.708a1.625 1.625 0 01-1.625-1.625v-6.5a1.625 1.625 0 011.625-1.625h.755c-.14.384-.213.79-.213 1.2a1.51 1.51 0 001.509 1.508H8.24a1.496 1.496 0 001.51-1.434 4.1 4.1 0 00-.186-1.274h.728a1.625 1.625 0 011.625 1.625v6.5z",
  fill: "#00273D"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13v13H0z"
}))));

var _ref87 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-ppl"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 8.667a3 3 0 110-6 3 3 0 010 6zM5 4a1.667 1.667 0 100 3.333A1.667 1.667 0 005 4zm5 11.333V15a5 5 0 10-10 0v.333a.667.667 0 101.333 0V15a3.666 3.666 0 117.334 0v.333a.667.667 0 101.333 0zM16 12a4.666 4.666 0 00-7.778-3.478.667.667 0 10.89.993A3.333 3.333 0 0114.666 12 .667.667 0 1016 12zm-4.333-6a3 3 0 110-6 3 3 0 010 6zm0-4.667a1.667 1.667 0 100 3.334 1.667 1.667 0 000-3.334z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref88 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.357 1.367L2.033 3.69a4.636 4.636 0 00-1.366 3.3v5.677A3.337 3.337 0 004 16h2a.667.667 0 000-1.333H4a2 2 0 01-2-2V6.99c0-.072.01-.142.018-.211.005-.038.01-.075.013-.112h3.302a2 2 0 002-2V1.365l.112-.013c.07-.01.14-.019.212-.019h3.01a2 2 0 012 2v.5a.667.667 0 101.333 0v-.5A3.337 3.337 0 0010.667 0h-3.01a4.636 4.636 0 00-3.3 1.367zM2.455 5.333c.143-.255.318-.49.521-.7L5.3 2.31c.21-.203.445-.378.7-.52v2.878a.667.667 0 01-.667.666H2.455z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.854 9.642l2.057-2.058a2.005 2.005 0 012.828 0l2.057 2.058a.669.669 0 01.009.95.666.666 0 01-.951-.008l-1.862-1.861v6.61a.667.667 0 11-1.334 0v-6.61l-1.862 1.861a.666.666 0 11-.942-.942z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "general-clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));

var _ref89 = /*#__PURE__*/React.createElement("symbol", {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-folders"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 2H8.315a.68.68 0 01-.298-.067L5.913.877a2.01 2.01 0 00-.894-.21H3.333A3.337 3.337 0 000 4v8a3.337 3.337 0 003.333 3.333h9.334A3.337 3.337 0 0016 12V5.333A3.337 3.337 0 0012.667 2zM3.333 2H5.02a.68.68 0 01.298.067L7.42 3.119c.277.14.583.213.894.214h4.352a2 2 0 011.852 1.255l-13.186.075V4a2 2 0 012-2zm9.334 12H3.333a2 2 0 01-2-2V5.996l13.334-.075V12a2 2 0 01-2 2z",
  fill: "#00273D"
}));

var _ref90 = /*#__PURE__*/React.createElement("symbol", {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-folder-add"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.667 10a.667.667 0 01-.667.667H8.667V12a.667.667 0 11-1.334 0v-1.333H6a.667.667 0 010-1.334h1.333V8a.667.667 0 011.334 0v1.333H10a.667.667 0 01.667.667zM16 5.333V12a3.337 3.337 0 01-3.333 3.333H3.333A3.337 3.337 0 010 12V4A3.337 3.337 0 013.333.667H5.02c.31 0 .616.072.894.21l2.104 1.056A.677.677 0 008.315 2h4.352A3.337 3.337 0 0116 5.333zM1.333 4v.667h13.211a2 2 0 00-1.877-1.334H8.315a2.01 2.01 0 01-.894-.21L5.317 2.07A.677.677 0 005.019 2H3.333a2 2 0 00-2 2zm13.334 8V6H1.333v6a2 2 0 002 2h9.334a2 2 0 002-2z"
}));

var _ref91 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13",
  id: "general-icon-sort-by"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.38 5.5h4.24a.369.369 0 00.211-.067.392.392 0 00.14-.177.41.41 0 00-.082-.431l-2.12-2.21A.372.372 0 006.5 2.5c-.1 0-.197.042-.268.116l-2.12 2.209a.41.41 0 00-.082.43.392.392 0 00.139.178.369.369 0 00.21.067z",
  fill: "#00273D"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M4.38 7.5h4.24c.076 0 .149.023.211.067a.392.392 0 01.14.177.41.41 0 01-.082.431l-2.12 2.21a.372.372 0 01-.269.115.372.372 0 01-.268-.116l-2.12-2.209a.41.41 0 01-.082-.43.392.392 0 01.139-.178.369.369 0 01.21-.067z",
  fill: "#00273D"
}));

var _ref92 = /*#__PURE__*/React.createElement("symbol", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  id: "general-icon-sort-by-desc"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "a",
  viewBox: "0 0 13 13",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.38 7.5h4.24c.076 0 .149.023.211.067a.392.392 0 01.14.177.41.41 0 01-.082.431l-2.12 2.21a.372.372 0 01-.269.115.372.372 0 01-.268-.116l-2.12-2.209a.41.41 0 01-.082-.43.392.392 0 01.139-.178.369.369 0 01.21-.067z",
  fill: "#00273D",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.38 5.5h4.24a.369.369 0 00.211-.067.392.392 0 00.14-.177.41.41 0 00-.082-.431l-2.12-2.21A.372.372 0 006.5 2.5c-.1 0-.197.042-.268.116l-2.12 2.209a.41.41 0 00-.082.43.392.392 0 00.139.178.369.369 0 00.21.067z",
  fill: "#00273D"
}))), /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("use", {
  transform: "rotate(-180 68 125) scale(12.3077)",
  x: -0.975,
  xlinkHref: "#a",
  y: 3.656
}));

var _ref93 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-active-list"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#EA561E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.667 4h10.666a.667.667 0 100-1.333H4.667a.667.667 0 000 1.333zm10.666 3.333H4.667a.667.667 0 000 1.334h10.666a.667.667 0 100-1.334zm0 4.667H4.667a.666.666 0 100 1.333h10.666a.667.667 0 100-1.333zm-14-7.333a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667zm0 4.666a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm0 4.667a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z",
  fill: "#EA561E"
})));

var _ref94 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-dot"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 2,
  fill: "#00273D",
  fillOpacity: 0.4
}));

var _ref95 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  id: "general-chevron-down-active"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#EA561E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.472 5.471a.667.667 0 00-.943 0L8.472 8.53a.68.68 0 01-.943 0L4.472 5.47a.667.667 0 00-.943.943L6.586 9.47a2 2 0 002.828 0l3.058-3.057a.667.667 0 000-.943z",
  fill: "#EA561E"
})));

var _ref96 = /*#__PURE__*/React.createElement("symbol", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  id: "general-loader"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61.496 279.61C60.508 271.374 60 263.194 60 256c0-107.402 88.598-196 196-196 50.098 0 97 20.2 131.5 51.7l-17.3 17.6c-3.9 3.9-5.4 9.598-3.9 15 1.802 5.098 6 9 11.4 10.2 3.019.605 102.214 32.57 95.898 31.3 8.035 2.677 19.918-5.894 17.703-17.698-.61-3.024-22.57-113.215-21.301-106.903-1.2-5.398-5.102-9.898-10.5-11.398-5.098-1.5-10.8 0-14.7 3.898l-14.698 14.399C384.8 25.8 322.598 0 256 0 115.3 0 0 115.3 0 256v.598c0 8.457.387 14.992.836 19.992a14.999 14.999 0 0012.004 13.36l30.816 6.16c10.032 2.007 19.051-6.403 17.84-16.5zm437.754-57.583l-30.906-6.297c-10.043-2.046-19.125 6.372-17.89 16.516C451.523 241 452 249.512 452 256c0 107.398-88.598 196-196 196-50.098 0-97-20.2-131.5-52l17.3-17.3c3.9-3.9 5.4-9.598 3.9-15-1.802-5.102-6-9-11.4-10.2-3.019-.61-102.214-32.57-95.898-31.3-5.101-.9-10.203.6-13.5 4.198-3.601 3.301-5.101 8.7-4.203 13.5.61 3.02 22.574 112.211 21.305 105.899 1.195 5.402 5.098 9.902 10.496 11.398 6.262 1.57 11.488-.328 14.7-3.898l14.402-14.399C126.898 485.2 189.102 512 256 512c140.7 0 256-115.3 256-256v-.902c0-6.649-.242-13.176-.797-19.664a14.994 14.994 0 00-11.953-13.407zm0 0"
}));

var _ref97 = /*#__PURE__*/React.createElement("symbol", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  id: "general-eye"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M499.4 250.8c-51-86.3-143.6-140.4-243.4-140.4S63.5 164.5 12.6 250.8c-2.1 3.1-2.1 7.3 0 10.4 51 86.3 143.6 140.4 243.4 140.4s192.5-54.1 243.4-140.4c2.1-3.1 2.1-7.3 0-10.4zM256 380.8C165.5 380.8 81.2 333 34.4 256 81.2 179 165.5 131.2 256 131.2S430.8 179 477.6 256C430.8 333 346.5 380.8 256 380.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 162.4c-52 0-93.6 41.6-93.6 93.6 0 52 41.6 93.6 93.6 93.6s93.6-41.6 93.6-93.6c0-52-41.6-93.6-93.6-93.6zm0 166.4c-40.6 0-72.8-32.3-72.8-72.8s32.3-72.8 72.8-72.8 72.8 32.3 72.8 72.8-32.2 72.8-72.8 72.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256 214.4v20.8c11.4 0 20.8 9.4 20.8 20.8s-9.4 20.8-20.8 20.8-20.8-9.4-20.8-20.8h-20.8c0 22.9 18.7 41.6 41.6 41.6 22.9 0 41.6-18.7 41.6-41.6s-18.7-41.6-41.6-41.6z"
})));

var SvgGeneral = function SvgGeneral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, "\n  //USERSETTINGS\n      ", _ref66, "\n//MAINMENU\n  ", _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGeneral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general.aa2ceb48.svg";
export { ForwardRef as ReactComponent };